Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.AbstractSectionView extends Backbone.View

  initialize: (@options = {}) ->
    # just set @options

  getSpecificSettings: ->
    @specific_settings || {}

  getTemplateOptions: ->
    @getSpecificSettings().templateOptions || {}

  getExtraQuery: ->
    @getSpecificSettings().extraQuery || {}

  bindChartsReady: (total) ->
    @pending_charts = total
    @bind('chartReady', @chartReadyCallback)

  chartReady: (div_id)->
    @trigger('chartReady')
    @$el.find(div_id).removeClass('processing')

  chartReadyCallback: ->
    @pending_charts -= 1
    if @pending_charts == 0
      @trigger('sectionReady')

  labelFilter: ->
    labels = [].concat @options.settings.accountLabel.codes
    for label in @options.settings.competitorsLabels
      labels = labels.concat label.codes
    labels

  labelsStructure: ->
    labels = [ @options.settings.accountLabel.codes ]
    for label in @options.settings.competitorsLabels
      labels.push(label.codes)
    labels

  baseQuery: (dimension) ->
    {
      dimension: dimension
      date_from_ISO: @options.fromISO.toISOString()
      date_to_ISO: @options.toISO.toISOString()
      exclude_page_owner_generated: true
      fb_parent_post_is_published: true
      not: { sub_type: ['direct-message', 'fb-message'] }
    }

  extendedQuery: (queryValues) ->
    query = {
      date_from_ISO: @options.fromISO.toISOString()
      date_to_ISO: @options.toISO.toISOString()
      exclude_page_owner_generated: true
      fb_parent_post_is_published: true
      not: { sub_type: ['direct-message', 'fb-message'] }
    }
    for key of queryValues
      query[key] = queryValues[key]
    return query

  accountSentimentQuery: ->
    @extendedQuery({dimension: 'sentiment', labels: @options.settings.accountLabel.codes})

  competitorSentimentQuery: (competitor_codes) ->
    @extendedQuery({dimension: 'sentiment', labels: competitor_codes})

  labelsQuery: (lista, structure) ->
    query = {dimension: 'filtered_labels', labels: lista}
    query.labels_structure = structure if structure
    @extendedQuery(query)

  _removeMissing: (response) ->
    if(response.series && response.series.length > 0)
      if(response.series.length > 1)
        data= response.series
      else
        data = response.series[0].data
    contentWithoutSentiment = _.find(data, (obj) -> obj.code == 'missing')
    if contentWithoutSentiment
      index = data.indexOf(contentWithoutSentiment)
      data.splice(index, 1)

  _sortedResponse: (response) ->
    if(response.series && response.series.length == 1)
      compare = (a,b) ->
        if (a.y < b.y)
          return 1
        if (a.y > b.y)
          return -1
        return 0
      response.series[0].data.sort(compare)
    return response

  _series: (response, name = 'Count') ->
    @_setDataColors(response.levels)
    series = []
    length = response.levels.length
    for i in [length-1..0]
      series.push({
        name: name
        data: response.levels[i]
        size: "#{100*(i+1)/length}%"
      })
    series

  _setDataColors: (levels) ->
    for level in levels
      for point in level
        if point.hidden or point.y == 0
          point.color = "rgba(0,0,0,0)"
        else
          point.color = @_colorWithDepth point.main_branch, point.level
          point.borderColor = "#DDD"

  tagsPieOptions: (response, divId, options={}) =>
    series = @_series(levels: [response.levels[0]])
    for serie in series
      serie.events = {
        click: (evt) =>
          @openDrillDown(options.drillDownFunction(evt))
      }
    
    chart_options = {
      chart:
        renderTo: @$el.find(divId).get(0)
        type: "pie"
        backgroundColor:'transparent'
      title:
        text: null
      plotOptions:
        pie:
          dataLabels:{enabled: false}
      legend:
        enabled: false
      exporting:
        enabled: true
      series: series
    }
    #chart_options.plotOptions.pie.size = options.size
    chart_options

  takeRange: (data) =>
      new_data = []
      rangeSize = @options.settings.topTagsAmount
      exceptions = @options.settings.topTagsExceptions
      _.each(data, (tag) =>
        unless _.contains(exceptions, tag.name)
          new_counter = new_data.length
          if new_counter < rangeSize
            new_data[new_counter] = tag
          else
            new_data = _.sortBy(new_data, 'y')
            search_index = _.findIndex(new_data, (return_tag) => 
              return_tag.y < tag.y
            )
            if search_index >= 0
              new_data[search_index] = tag
      )
      new_data

  hierarchyPieOptions: (response, divId, options={}) =>
    series = @_series(levels: [response.levels[0]])
    for serie in series
      serie.events = {
        click: (evt) =>
          @openDrillDown(options.drillDownFunction(evt))
      }
    {
      chart:
        renderTo: @$el.find(divId).get(0)
        type: "pie"
        backgroundColor:'transparent'
        margin: [0, 0, 0, 0]
      title:
        text: null
      plotOptions:
        pie:
          borderColor: "rgba(0,0,0,0)"
          dataLabels:
            enabled: false
      legend:
        enabled: false
      exporting:
        enabled: true
      series: series
    }


  barOptions: (response, divId, options={}) =>
    series = response.series
    for serie in series
      serie.type = "bar"
    categories = []
    for point in series[0].data
      categories.push point.code
    for serie, i in series
      for point in serie.data
        point.color = @colors[point.code]
        if point.benchmark.increase < 0
          point.benchmark.increase = '- ' + point.benchmark.increase + '%'
        else 
          point.benchmark.increase = '+ ' + point.benchmark.increase + '%'
    @highchartsBarOptions(divId, series, categories, options)

  highchartsBarOptions: (divId, series, categories, options={}) ->
    ret = {
      chart:
        backgroundColor: null
        renderTo: @$el.find(divId).get(0)
        type: 'bar'
      series: series
      plotOptions:
        series:
          dataLabels: 
            formatter: () -> if @point.benchmark.increase then @point.benchmark.increase
            enabled: true
      legend:
        enabled: false
      exporting:
        enabled: true
      title:
        text: null
      yAxis:
        title:
          enabled: false
      xAxis:
        categories: categories
    }
    ret.chart.height = options.height if options.height
    ret

  _colorWithDepth: (name, level) ->
    color = @_getColor name
    for i in [0,1,2]
      color[i] += 20*(level-1)
      color[i] = Math.max(0, color[i])
    "rgb(#{color[0]},#{color[1]},#{color[2]})"

  _getColor: (name) ->
    colors = [
      [150, 50, 150],
      [200, 50, 50],
      [50, 150, 150],
      [50, 100, 150],
      [50, 150, 100],
      [100, 150, 50],
      [100, 50, 150],
      [150, 50, 100],
      [230, 200, 100],
      [125, 175, 100],
      [100, 125, 175],
      [125, 125, 175]
    ]
    @nextColor ||= 0
    @map ||= {}
    if @map[name]
      color = @map[name].slice(0)
    else
      color = colors[@nextColor]
      @map[name] = colors[@nextColor].slice(0)
      @nextColor = (@nextColor+1) % colors.length
    color

  histogramOptions: (response, div_id, options={}) =>
    default_options = {
      drillDownFunction: $.noop
    }
    options = $.extend({}, default_options, options)

    series = response.series
    pointStart = series[0]?.data?[0]?[0] || 0
    interval = Math.abs(pointStart - (series[0]?.data?[1]?[0] || 0))

    if response.benchmark_data && response.benchmark_data.length > 0
      series.push({ code: 'Benchmark', name: 'Benchmark', data: response.benchmark_data[0].data })
    for serie in series
      serie.color = @colors[serie.code]
      serie.data = _.map(serie.data, (data) -> data[1])
      serie.events = {
        click: (evt) =>
          @openDrillDown(options.drillDownFunction(evt))
      }
    {
    chart:
      renderTo: @$el.find(div_id).get(0)
      backgroundColor: null
      type: 'spline'
    series: series
    plotOptions:
      spline:
        marker:
          enabled: false
        pointInterval: interval
        pointStart: pointStart
    legend:
      enabled: true
    xAxis:
      type: 'datetime'
    yAxis:
      min: 0
      title:
        text: null
    title:
      text: null
    exporting:
      enabled: true
    }

  _addChart: (target, optionsFunction) =>
    (query, div_id, options={}) =>
      @$el.find(div_id).addClass('processing')
      $.post(target, query, (response) =>
        @drawChart(response, div_id, optionsFunction, options)
      )

  drawChart: (response, div_id, optionsFunction, options={}) ->
    callback           = options.callback
    prepareColors      = options.prepareColors
    orderResult        = options.orderResult
    highchartsFunction = options.highchartsFunction || $.noop

    chartOptions = {
      drillDownFunction: (options.drillDownFunction || $.noop),
      size: (options.size)
      height: (options.height)
    }
    if options.reducedRange 
      response.levels[0] = @takeRange(response.levels[0])
    @_removeMissing(response)
    orderResult(response) if orderResult
    prepareColors(response) if prepareColors
    # new Highcharts.Chart(optionsFunction(response, @$el.find(div_id), { drillDownFunction: drillDownFunction } ), highchartsFunction)
    new Highcharts.Chart(optionsFunction(response, @$el.find(div_id), chartOptions), highchartsFunction)
    callback(response, div_id) if callback
    @chartReady(div_id)

  setBenchmarkSettingsIfNecessary: (query) ->
    @setBenchmarkSettings(query) if @getSpecificSettings().benchmark

  setBenchmarkSettings: (query) ->
    query.benchmark = @benchmarkSettings()

  benchmarkSettings: ->
    {
      date_from_ISO: @options.fromBenchmark.toISOString(),
      date_to_ISO: @options.toBenchmark.toISOString()
    }


  # _addHistogram: (query, div_id, callback=null, prepareColors=null) ->
  _addHistogram: (query, div_id, options={}) ->
    f = @_addChart(@options.chartApi.histogram, @histogramOptions)
    query.interval = 60*24 # 1 day in minutes
    @setBenchmarkSettingsIfNecessary(query)
    f(query, div_id, options)

  _addPie: (query, div_id, options={}) ->
    f = @_addChart(@options.chartApi.singleDimension, @pieOptions)
    f(query, div_id, $.extend({}, options, {orderResult: @_sortedResponse}))

  _addBars: (query, div_id, options={}) ->
    f = @_addChart(@options.chartApi.crossDimension, @columnOptions)
    f(query, div_id, options)

  _addSimpleColumns: (query, div_id, options={}) ->
    f = @_addChart(@options.chartApi.singleDimension, @columnOptions)
    f(query, div_id, options)

  _addNotStackedColumns: (query, div_id, options={}) ->
    f = @_addChart(@options.chartApi.crossDimension, @columnNotStackedOptions)
    f(query, div_id, options)

  _addHierarchy: (query, div_id, options={}) ->
    f = @_addChart(@options.chartApi.hierarchy, @hierarchyPieOptions)
    f(query, div_id, options)

  _addTagsPie: (query, div_id, options={}) ->
    f = @_addChart(@options.chartApi.hierarchy, @tagsPieOptions)
    f(query, div_id, options)

  _addHorizontalBars: (query, div_id, endpoint, options={}) ->
    f = @_addChart(@options.chartApi[endpoint], @barOptions)
    f(query, div_id, options)

  prepareColors: (response) =>
    if(!@colors)
      @colors = {}
    series = response.series
    if(series.length > 0)
      color_count = @options.settings.customColors.length
      for point, index in series[0].data
        point.color = @colors[point.code] || @colors[point.name] || @options.settings.customColors[index % color_count]
        point.index = index+1
        @colors[point.code] = point.color

  drillDownUrl: (params = {}) ->
    query = @drillDownExtendedQuery(params)
    "#{@options.application_base_url}/monitoring/dashboard?drill_down=true&#{$.param(query)}"

  drillDownBaseQuery: ->
    @extendedQuery({
      account_id: Keepcon.currentAccount.id
      labels: @options.settings.accountLabel.codes
      date_from: @_formatDate(@options.fromISO)
      date_to: @_formatDate(@options.toISO)
    })

  drillDownExtendedQuery: (more_params = {}) ->
    $.extend({}, @drillDownBaseQuery(), more_params)

  openDrillDown: (params) ->
    window.open(@drillDownUrl(params), '_blank')

  # Duplicated in search_query.coffee
  _formatDate: (date) ->
    monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return "#{date.getDate()} #{monthNames[date.getMonth()]} #{date.getFullYear()} #{date.toTimeString().substring(0,5)}"

  pieOptions: (response, divId, options={}) =>
    default_options = {
      fivePies: false
      drillDownFunction: (clickEvent) -> {}
    }
    options = $.extend({}, default_options, options)

    series = response.series
    series[0].type = 'pie'
    series[0].events = {
      click: (evt) => @openDrillDown(options.drillDownFunction(evt))
    }
    for point in series[0].data
      point.color = @colors[point.code]
    ret = {
      chart:
        backgroundColor: null
        renderTo: @$el.find(divId).get(0)
        spacing: [0, 0, 0, 0]
      tooltip:
        formatter: () ->
          @point.name + ": " + @point.y
      series: series
      plotOptions:
        pie:
          dataLabels:{formatter: () -> if @y then @y else 0}
      exporting:
        enabled: true
        sourceWidth: if options.fivePies then 1170 else undefined
        sourceHeight: if options.fivePies then 300 else undefined
      title:
        text: null
    }
    ret.plotOptions.pie.size = options.size if options.size
    ret

  columnOptions: (response, divId, options={}) =>
    series = response.series
    for serie in series
      serie.type = 'column'
      serie.events = {
        click: (evt) => @openDrillDown(options.drillDownFunction(evt))
      }
    categories = []
    for point in series[0].data
      categories.push point.code
    for serie, i in series
      for point in serie.data
        color = @colors[point.code].split ","
        opacity = 1-i/3
        color[3] = opacity+")"
        color = color.toString()
        point.color = color

    @highchartsColumnOptions(divId, series, categories)

  highchartsColumnOptions: (divId, series, categories) ->
    {
      chart:
        backgroundColor: null
        renderTo: @$el.find(divId).get(0)
      series: series
      plotOptions:
        column:
          stacking: true
      exporting:
        enabled: true
      title:
        text: null
      legend:
        enabled: false
      yAxis:
        title:
          enabled: false
      xAxis:
        categories: categories
    }

  columnNotStackedOptions: (response, divId, options={}) =>
    series = response.series
    for serie in series
      serie.type = 'column'
      serie.events = {
        click: (evt) => @openDrillDown(options.drillDownFunction(evt))
      }
    categories = []
    for point in series[0].data
      categories.push point.code
    for serie, i in series
      color = @colors[serie.code]
      for point in serie.data
        point.color = color

    @highchartsColumnNotStackedOptions(divId, series, categories)

  highchartsColumnNotStackedOptions: (divId, series, categories) ->
    {
      chart:
        backgroundColor: null
        renderTo: @$el.find(divId).get(0)
      series: series
      exporting:
        enabled: true
      title:
        text: null
      legend:
        enabled: false
      yAxis:
        title:
          enabled: false
      xAxis:
        categories: categories
    }

  _percentage: (value, total) ->
    Math.round(10000*(value/total)) / 100

  addLabels: (response, div_id) =>
    legends = []
    total = 0
    for point in response.levels[0]
      total += point.y

    for point in response.levels[0]
      if point.y > 0
        legends.push {
          tag: point.main_branch
          value: point.y + " (" + (point.y / total * 100).toFixed(2) + "%)"
          color: @_colorWithDepth(point.main_branch, 1)
        }
    legends = _.sortBy(legends, (legend) -> -legend.value )
    $legend = $(@legendsTemplate(legends: legends)).addClass('references')
    @$el.find(div_id).append($legend)

  addWordsCloud: (data, divSelector) ->
    $el = @$el.find(divSelector)
    @width = $el.width()
    @height = $el.height()

    container = @$el.find(divSelector)
    container.append('<div style="width:'+@width+'px;height:'+@height+'px;position: relative;overflow: hidden; overflow-x: hidden;"></div>')
    canvas = container.find('div')
    canvas.on('wordcloudstop', @addDownloadButton)

    renderer = new Monitoring.Methods.RenderWordCloud(data.topic_ranking, {
      weightFactor: 1
      fontFamily: 'Helvetica'
      backgroundColor: 'rgba(255,255,255,0)'
    })
    renderer.renderInElement(canvas[0])

    @chartReady(divSelector)

  _renderPostsPreviews: ->
    twttr.widgets.load()

    @$('.fb-post-container').each (i,e) ->
      FB.XFBML.parse(e)

  _colorsByBrands: ->
    finalColors = []
    if(!@colors)
      @colors = {}
    colors_by_brands = []
    _.each(@colors, (value, key) =>
      color = {}
      color['brand'] = key
      color['color'] = value
      color['clearer_color'] = value.replace /1\)/, "0.66)"
      colors_by_brands.push color
    )
    colors_by_brands
